import { render, staticRenderFns } from "./player.vue?vue&type=template&id=61076ed3&"
import script from "./player.vue?vue&type=script&lang=ts&"
export * from "./player.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports